.cnc-label-field-container {
  display: flex;
  align-items: center;
  color: var(--base-text-default);
  .sm {
    font-weight: 600;
    font-size: 12px;
  }
  .md {
    font-weight: 600;
    font-size: 14px;
  }
  .lg {
    font-weight: 600;
    font-size: 16px;
  }
}
